import { 
	EFinaceToggleTypes,
	EFinanceTypes, 
	ESpecialTypes 
} from '@/enums';
import { 
	changeSwatchesInDocument,
	getCodes,
	getCookie,
	getDisclaimerKey,
	getUpdatedFakeColourElements,
	shouldShowPricing
} from '@/helpers';
import { 
	getVehicleImages, 
	getVehiclePricing, 
	getDemoVehicleImages
} from '@/api';

import { 
	IDetailAppState, 
	IVehicle,
	IVehiclePricing,
	IVehicleImages, 
	IRoofOption,
	IVehicleImage360,
	IFakeColourElements,
	IOpeningInfoItem,
	IAdvantageDataItem,
	ISources,
	FSLApiData,
	DisclaimerItem,
} from '@/types';

const state: IDetailAppState = {
	disclaimers: [],
	isFslLoading: false,
	fsl: null, 
	selectedFinanceType: EFinaceToggleTypes.finance,
	showExternalCustomise: true,
	originalBatch: '',
	disableNewDisclaimer: false,
	fakeSpecial: (location.href.includes('localhost:') || location.href.includes('test.dealer')) && location.search.includes('fakeSpecial=true'),
	debug: (location.href.includes('localhost:') || location.href.includes('test.dealer')) && location.search.includes('test=1'),
	isLoading: false,
	screenSize: 0,
	screenHeight: 0,
	openingInfo: [],
	form_token: "",
	form_privacy: [],
	tprSource: null,
	fakeColourEls: {
		hash: '',
		currrentvariantcode: '',
		originalvariantcode: '',
		paints: [],
		trims: [],
		roofs: []
	},
	vehicle: {
		Batch: "",//for demo
		VehicleLine: "",
		FullDescription: "",
		FullDescriptionForFinance: "",
		IsVirtual: false,
		VirtualVehicleId: "",
		SpecificationId: "",
		VsId: 0,
		Dealer: {
			Postcode: "",
			DealerId: 0,
			ActualDealerId: 0,
			DealerCode: "",
			Locations: [], 
			ClickToCalls: []
		},
		BaseModelCode: "",
		Year: "",
		PlannedMonth: "",
		OrderEnabled: false,
		CurrentVariantCode: "",
		VariantCode: "",
		PaintCode: "",
		RoofCode: "",
		TrimCode: "",
		Paints: [],
		Trims: [],
		Roofs: [], 
		VehicleType: "",
		Vin: "",
		Grade: "",
		Transmission: "",
		HasTprApplied: false,
		PageType: "", 
		Price: "", 
		FactoryOption: "", 
		Rego: "",
		Offers: []
	}, 
	demoImages: [],
	images: {
		DefaultFrame: "",
		Path_360: [],
		Path_Int: [],
		Path_Ext: [],
		Path_Hero: [],
		Path_Video: [],
		Path_CubeMap: []
	}, 
	pricing: {
		materialcode: "",
		driveaway: "",
		financeDisclaimerKey: "",
		financerate: "",
		financeweekly: "",
		financeType: 1,
		isNationalSpecial: false,
		isDealerSpecial: false,
		stockDescription: "",
		specialApplied: "",
		specialDisclaimerKey: "",
		specialExtra: "",
		priceType: "",
		vin: "",
		buildyear: "",
		specialItem: null,
		batch: "",
		isCabChassis: false,
		isZeroPrice: true,
		wasFinanced: false,
		stockType: 1,
		priceresult: {
			DriveAwayPrice: 0,
			responseCode: "",
			RRP: null,
			StampDuty: null,
			DealerDeliveryFees: null,
			LCT: null,
			RegistrationFees: null,
			callresult: {
				materialNumber: null,
				DriveAwayPrice: 0,
				ListPrice: 0,
				OptionsPrice: 0,
				AccessoriesPrice: 0,
				DealerDelivery: 0,
				LuxuryCarTax: 0,
				PostCode: "",
				OnRoadCosts: {
					StampDuty: 0,
					TotalRegistration: 0,
					RegistrationAmount: 0,
					CtpInsuranceAmount: 0
				}
			}
		},
		financeDisclaimer: "",
		canBePurchased: false,
		storeUrl: "",
		financeYears: "",
		financeTotalKms: "",
		financeHeading: "",
		internalFinanceType: "",
		cmpFrom: "",
		cmpTo: "",
		creditScore: "",
		storeWhyBuy: "",
		APR: "",
		IsTPR: false,
		TprEnabled: false,
		HideTprUntilMatrix: false,
		CtaEnabled: false, 
		PricingMessage: false,
		Offers: []
	},
	advantages: [], 
	hasSubmittedFinanceCampaignEnquiry: !!getCookie('hasSubmittedFinanceCampaignEnquiry')
};
const getters = {
	isDemo: (state: IDetailAppState): boolean => {
		return !state.vehicle.CurrentVariantCode && !!state.originalBatch;
	},
	isGreatValue: (state: IDetailAppState): boolean => {
		return state.pricing.specialItem?.SpecialType == ESpecialTypes.greatValue;
	},
	isSpecialOffer: (state: IDetailAppState): boolean => {
		return state.pricing.specialItem?.SpecialType == ESpecialTypes.specialOffer;
	},
	isDealerSpecial: (state: IDetailAppState): boolean => {
		return state.pricing.isDealerSpecial;
	},
	specialExtraDisplayed: (state: IDetailAppState): string => {
		return state.pricing.specialItem?.SpecialExtra?.join(', ') || '';
	},
	priceDisplayed: (state: IDetailAppState): string => {
		if (shouldShowPricing(state.pricing)){
			const driveawayDisclaimerKey = getDisclaimerKey(state.pricing);
			return `${state.pricing.driveaway} driveaway ${driveawayDisclaimerKey}`;
		}
		return '';
	},
	comparisonRate: (state: IDetailAppState): string => {
		if (state.vehicle.IsVirtual){
			return (state.pricing.financeType === EFinanceTypes.AccessConsumer || state.pricing.financeType === EFinanceTypes.Consumer) ? state.pricing.financerate + '% Comparision rate' : '';
		}
		else {
			// todo: get from el
			return '';
		}
	},
	financeType: (state: IDetailAppState): string =>  {
		if (state.vehicle.IsVirtual){
			if (state.pricing.financeType === EFinanceTypes.AccessConsumer) {
				return "Consumer Loan Access";
			}
			if (state.pricing.financeType === EFinanceTypes.AccessBusiness) {
				return "Business Loan Access";
			}
			if (state.pricing.financeType === EFinanceTypes.Business) {
				return "Business Loan";
			}
			if (state.pricing.financeType === EFinanceTypes.Consumer) {
				return "Consumer Loan";
			}
			return "";
		}
		else {
			// todo: get from el
			return '';
		}
	},
	financeDisplayed: (state: IDetailAppState, getters: any): string => {
		if (state.vehicle.IsVirtual){
			if (!state.pricing.HideTprUntilMatrix){
				const comparisonrate = getters['comparisonRate'];
				const financetype = getters['financeType'];
				return `${state.pricing.financeweekly}/wk ${comparisonrate} ${financetype}`;
			}
			else return '';
		}
		else {
			// todo: get from el
			return '';
		}
	},
	vehicleHash: (state: IDetailAppState, getters: any): string => 
		state.vehicle.IsVirtual ? getters.fakeColourEls.hash : `${state.vehicle.CurrentVariantCode || ''}${state.vehicle.TrimCode || ''}${state.vehicle.Roofs.length ? state.vehicle.RoofCode || '' : state.vehicle.PaintCode || ''}`,
	fakeColourEls: (state: IDetailAppState): IFakeColourElements => state.fakeColourEls,
	roofs: (state: IDetailAppState): Array<IRoofOption> => state.vehicle.Roofs,
}
const mutations = {
	setDisableNewDisclaimer(state: IDetailAppState, payload: boolean){
		state.disableNewDisclaimer = payload;
	},
	setIsFslLoading(state: IDetailAppState, payload: boolean){
		state.isFslLoading = payload;
	},
	setFsl(state: IDetailAppState, payload: FSLApiData | null){
		state.fsl = payload;
	},
	setSelectedFinanceType(state: IDetailAppState, payload: EFinaceToggleTypes){
		state.selectedFinanceType = payload;
	},
	setOriginalBatch(state: IDetailAppState, payload: string){
		state.originalBatch = payload;
	},
	setFormPrivacy(state: IDetailAppState, payload: Array<string>){
		state.form_privacy = payload;
	},
	setFormToken(state: IDetailAppState, payload: string){
		state.form_token = payload;
	},
	setOpeningInfo(state: IDetailAppState, payload: Array<IOpeningInfoItem>){
		state.openingInfo = payload;
	},
	setDemoImages(state: IDetailAppState, payload: Array<string>){
		state.demoImages = payload;
	},
	setImages(state: IDetailAppState, payload: IVehicleImages){
		state.images = payload;
	},
	setImages360(state: IDetailAppState, payload: Array<IVehicleImage360>){
		state.images.Path_360 = payload;
	},
	setIsLoading(state: IDetailAppState, payload: boolean){
		state.isLoading = payload;
	},
	setScreenSize(state: IDetailAppState, payload: number){
		state.screenSize = payload;
	},
	setScreenHeight(state: IDetailAppState, payload: number){
		state.screenHeight = payload;
	},
	setVehicle(state: IDetailAppState, payload: IVehicle){
		state.vehicle = payload;
	},
	setPricing(state: IDetailAppState, payload: IVehiclePricing){
		state.pricing = payload;
	},
	setPaintActive(state: IDetailAppState, payload: string){
		state.vehicle.PaintCode = payload;
	},
	setTrimActive(state: IDetailAppState, payload: string){
		state.vehicle.TrimCode = payload;
	},
	setRoofActive(state: IDetailAppState, payload: string){
		state.vehicle.RoofCode = payload;
	},
	setVariantActive(state: IDetailAppState, payload: string){
		state.vehicle.CurrentVariantCode = payload;
	}, 
	setFakeColourEls(state: IDetailAppState, payload: IFakeColourElements){
		state.fakeColourEls = payload;
	},
	setAdvantages(state: IDetailAppState, payload: Array<IAdvantageDataItem>){
		state.advantages = payload;
	},
	setSources(state: IDetailAppState, payload: ISources){
		state.tprSource = payload.tprSource;
	},
	setDisclaimers(state: IDetailAppState, payload: Array<DisclaimerItem>){
		(state.disclaimers as any) = payload;
	},
	addDisclaimer(state: IDetailAppState, payload: DisclaimerItem){
		(state.disclaimers as any) = [...state.disclaimers, payload];
	},
};
const actions = {
	handleInitialLoad({ dispatch, commit, getters }: { dispatch: any, commit: any, getters: any }, initialVehicle: IVehicle){
		if (initialVehicle.IsVirtual){
			const hashMaterial: string = (window.location.hash || '').split('&')[0].replace('#','');
			const isHashValid = hashMaterial.length == 16;
			const initialCode = `${initialVehicle.CurrentVariantCode}${initialVehicle.TrimCode}${initialVehicle.Roofs.length ? initialVehicle.RoofCode : initialVehicle.PaintCode}`;
			const fakeEls = getUpdatedFakeColourElements(null, isHashValid ? hashMaterial : initialCode, initialVehicle, null);

			commit('setFakeColourEls', fakeEls)
			if (initialCode != fakeEls.hash){
				const codes = getCodes(fakeEls);
				
				initialVehicle.CurrentVariantCode = codes.variantCode;
				initialVehicle.TrimCode = codes.trimCode;
				initialVehicle.RoofCode = codes.roofCode;
				initialVehicle.PaintCode = codes.paintCode;
				commit('setVehicle', initialVehicle);
			}
			dispatch('setHash');
			dispatch('handleVehicleChange');
		}
	},
	setHash({ getters }: { getters: any }): void {
		const h = getters.fakeColourEls.hash;
		(window as any).location.hash = h;
	},
	async handleVehicleChange({ commit, getters, state, dispatch }: { commit: any, getters: any, state: any, dispatch: any }): Promise<void> {
		commit('setIsLoading', true);
		const hash = getters.vehicleHash;
		const images: IVehicleImages = await getVehicleImages(hash, state.vehicle.PlannedMonth);
		commit('setImages', images);
		if (state.vehicle.IsVirtual){
			changeSwatchesInDocument(state.vehicle);
			const pricing: IVehiclePricing = await getVehiclePricing(state.vehicle, hash, state.fakeSpecial);
			commit('setPricing', pricing);
			commit('setDisableNewDisclaimer', !pricing.PricingMessage);
			dispatch('sendDetailAnalytics');
		}
		commit('setIsLoading', false);
	}, 
	async loadDemoImages({ commit, state }: { commit: any, state: any }){
		const v = state.vehicle;
		if (!v.Batch) return;
		const imgs = await getDemoVehicleImages(v.Dealer.DealerId, v.Batch);
		if (!imgs) return;
		commit('setDemoImages', imgs);
	}, 
	sendDetailAnalytics({ state, getters }: { state: IDetailAppState, getters: any }){
		const dataLayer = (window as any).dataLayer || [];
		const model = state.vehicle.VehicleLine;
		const tprcaseid = getCookie('tprcaseid') || '(not set)';
		const colour = state.vehicle.Paints.filter(o => o.PaintCode == state.vehicle.PaintCode).map(o => o.PaintName).toString();
		const trim = state.vehicle.Trims.filter(o => o.TrimCode == state.vehicle.TrimCode).map(o => o.TrimName).toString() || '';
		const isOnSpecial = state.pricing.isDealerSpecial || state.pricing.isNationalSpecial || state.pricing.specialItem?.SpecialType == ESpecialTypes.specialOffer;
		const driveaway = state.pricing.driveaway.replace('$','').replace(',','') || '(not set)';

		// const vehicleType = state.vehicle.IsVirtual ? "New Virtual" : state.vehicle.Batch ? "New In Stock" : ""
		// const pageType = state.vehicle.Batch ? "New Vehicle List Inventory Listing Page" "Dealer Specials Page" "In Stock Page";
		dataLayer.push({
			event:"view_item",
			has_tpr_applied: state.pricing.IsTPR ? 'Yes' : 'No',
			// Note if Vehicle Grade is not selected then the value should be ALL
			item_list_id: `nvi_${model}_${state.vehicle.Grade}`, 
			item_list_name: `New Vehicles - ${model} - ${state.vehicle.Grade}`,
			items: [
				{
					item_id: getters.vehicleHash || '(not set)',
					item_name:  state.vehicle.FullDescription || '(not set)',
					item_brand: "Toyota",
					item_category: "New Vehicles",
					item_category2: model || '(not set)',
					item_category3: state.vehicle.Grade || '(not set)',
					item_category4: state.vehicle.VehicleType || '(not set)',
					price: driveaway,
					quantity: 1,
				}
			],
			page_type: "New Vehicle Inventory Details Page",
			tpr_case_id: tprcaseid,
		});

		dataLayer.push({
			event:"new_vehicle_detail_view",
			has_tpr_applied: state.pricing.IsTPR ? 'Yes' : 'No',
			page_type: "New Vehicle Inventory Details Page",
			tpr_case_id: tprcaseid,
			vehicle_build_year: state.vehicle.Year || '(not set)',
			vehicle_colour: colour || '(not set)',
			vehicle_description: state.vehicle.FullDescription || '(not set)',
			vehicle_factory_options: state.vehicle.FactoryOption || '(not set)',
			vehicle_grade: state.vehicle.Grade || '(not set)',
			vehicle_identification_number: state.vehicle.VsId || '(not set)',
			vehicle_in_order_collect: state.pricing.canBePurchased,
			vehicle_material_code: getters.vehicleHash || '(not set)',
			vehicle_model: model || '(not set)',
			vehicle_on_special: isOnSpecial,
			vehicle_price: driveaway,
			vehicle_transmission: state.vehicle.Transmission || '(not set)',
			vehicle_trim: trim || '(not set)',
			vehicle_type:  state.vehicle.VehicleType || '(not set)', //New In Stock, New Virtual, Demonstrator
			vehicle_vin: state.vehicle.Vin || '(not set)',
		});
		return;
	}, 
	removeDisclaimer({ commit, state }: { commit: any, state: any }, payload: string){
		const disclaimers = state.disclaimers.filter((d: DisclaimerItem) => d['type'] != payload);
		commit('setDisclaimers', disclaimers);
	},
	addDisclaimer({ commit }: { commit: any }, payload: DisclaimerItem){
		commit('addDisclaimer', payload);
	},
	updateFooterDisclaimers({ state }: { state: any }): void {
		const disclaimerEl: HTMLDivElement | null = document.querySelector('.disclaimer.filter .content');
		if (!disclaimerEl) return;
		
		disclaimerEl.querySelectorAll('p[data-type]').forEach((o: any) => {
			o.parentElement?.removeChild(o);
		});
		state.disclaimers.forEach((o: DisclaimerItem) => {
			const newEl = document.createElement('p');
			newEl.innerHTML = o.key + ' ' + o.text;
			newEl.setAttribute('data-type', o.type);
			disclaimerEl.appendChild(newEl);
		});
	}
}
export default {
	namespaced: true,
	state, 
	getters,
	mutations, 
	actions
};